import React from 'react';
import { m } from 'framer-motion';
import { TagIcon, FileTextIcon, TruckIcon, RadarIcon, HeartHandshakeIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
const bonuses = [{
  icon: TagIcon,
  emoji: '💶',
  title: 'Bono 1: Guía de Precios "España"',
  value: '9,90€',
  isNew: false,
  text: 'Cuánto cobrar en tu zona para ganar dinero de verdad después de gastos. Tabla completa. Cálculo de margen. Sin secretos.'
}, {
  icon: FileTextIcon,
  emoji: '📋',
  title: 'Bono 2: Plantillas "Copia y Pega"',
  value: '12,90€',
  isNew: false,
  text: '30+ anuncios redactados que desactivan el regateo automáticamente. Textos para Wallapop, Instagram y WhatsApp. Listos para usar.'
}, {
  icon: TruckIcon,
  emoji: '🧾',
  title: 'Bono 3: Directorio de Proveedores',
  value: '9,90€',
  isNew: false,
  text: 'Dónde compramos los profesionales en España sin que nos claven. Leroy Merlin vs. almacenes locales. Presupuestos reales.'
}, {
  icon: RadarIcon,
  emoji: '📡',
  title: 'Bono 4: Radar de Demanda Local',
  value: '19,90€',
  isNew: true,
  text: 'Descubre en 15 minutos si un producto merece fabricarse antes de gastar madera, tiempo o dinero. Sistema de validación rápida usando Wallapop, Instagram y Etsy. Matriz de puntuación. Decisor final: fabricar, ajustar o descartar.'
}, {
  icon: HeartHandshakeIcon,
  emoji: '💌',
  title: 'Bono 5: Pack Cliente Feliz',
  value: '37,90€',
  isNew: true,
  text: 'Convierte cada entrega en experiencia premium que genera reseñas y recomendaciones. Tarjetas de cuidado, garantía, mensajes postventa listos para copiar y pegar. Sistema de seguimiento a 7 días. Entrega que vende.'
}];
export function BonusesDetail() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-22" data-mp="3go4amm52qsgl">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-23" data-mp="3gpp222w3dva8">
        <SectionTag icon="🎁" data-id="element-24" data-mp="2a8br9swlviut">5 Bonos estratégicos incluidos</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-25" data-mp="257web2g8kddd">
          Y además, recibes 5 bonos exclusivos.
        </h2>
        <p className="mt-4 text-base text-muted sm:text-lg" data-id="element-26" data-mp="26ns50jyxwg2l">
          Valor total de los bonos: <span className="text-ink line-through" data-id="element-27" data-mp="2bmlfs4mudsz2">89,50€</span> →{' '}
          <span className="font-semibold text-success" data-id="element-28" data-mp="1xo50hpawyu5b">Hoy: Incluido</span>
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-4xl gap-4 px-4 sm:px-6" data-id="element-29" data-mp="22mom1olli3x5">
        {bonuses.map((bonus, i) => <m.div key={bonus.title} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.06
      }} className="flex flex-col gap-4 rounded-2xl border border-brown/20 bg-white p-6 shadow-card sm:flex-row sm:items-start" data-id="element-30" data-mp="1nybpoqilij24" data-mpi={i}>
            <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-brown/10 text-2xl" data-id="element-31" data-mp="14zzd0ush6r1s">
              <span aria-hidden="true" data-id="element-32" data-mp="19y0y1l9gp0fw">{bonus.emoji}</span>
            </div>
            <div className="flex-1" data-id="element-33" data-mp="qcqxxiw1q1kj">
              <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-34" data-mp="qdsluny5uijo">
                <h3 className="flex flex-wrap items-center gap-2 font-heading text-base font-bold text-ink sm:text-lg" data-id="element-35" data-mp="lfr17yl36b63">
                  {bonus.title}
                  {bonus.isNew && <span className="rounded-full bg-action/15 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-action-hover" data-id="element-36" data-mp="vc3uwwgmsp0u">
                      ⭐ Nuevo
                    </span>}
                </h3>
                <span className="text-sm text-muted" data-id="element-37" data-mp="14ca6udwolgxw">
                  Valor: <span className="line-through" data-id="element-38" data-mp="1j27w6x6ckcoo">{bonus.value}</span>
                </span>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-39" data-mp="1e3egqz7i2blv">{bonus.text}</p>
            </div>
          </m.div>)}
      </div>

      <div className="mx-auto mt-6 max-w-2xl px-4 text-center sm:px-6" data-id="element-40" data-mp="1s3pbwefueccu">
        <p className="rounded-xl border border-success/25 bg-success/5 px-5 py-4 text-sm font-medium text-ink sm:text-base" data-id="element-41" data-mp="1o1ual9xwvyz2">
          Si compras estos 5 bonos por separado: <span className="line-through text-muted" data-id="element-42" data-mp="3hi72k49dtlyl">89,50€</span> →{' '}
          <span className="text-success" data-id="element-43" data-mp="3mhjn2ics6gy0">Incluidos sin coste adicional</span>
        </p>
      </div>
    </section>;
}